module.exports = __webpack_public_path__ + "static/media/lamina28act1_6.79a96dd0.png";